const globalLoadingId = 'chemical_global_loading';

const GlobalLoading = {
  show: (msg?: string) => {
    if (typeof window !== 'undefined' && document.getElementById(globalLoadingId)) return;
    if (typeof window === 'undefined') return;
    const loadingElement = document.createElement('div');
    loadingElement.id = globalLoadingId;
    loadingElement.className =
      'fixed w-screen h-screen top-0 left-0 z-[9999] bg-black/30 flex items-center justify-center flex-col';
    if (msg) {
      loadingElement.innerHTML = `<div class="c-loader"></div><p class='text-xl font-semibold'>${msg}</p>`;
    } else {
      loadingElement.innerHTML = `<div class="c-loader"></div>`;
    }

    document.body.appendChild(loadingElement);
  },

  hide: () => {
    if (typeof window === 'undefined') return;
    const loadingElement = document.getElementById(globalLoadingId);

    if (loadingElement) {
      document.body.removeChild(loadingElement);
    }
  },
};

export { GlobalLoading };
